import api from '@/api'
import notifier from '@/notifier'
import { merge } from 'lodash'

export default {
  namespaced: true,
  state: {
    total: 0,
    announcementsMigration: [],
    fetching: false,
    lastFetchOptions: null
  },
  actions: {
    async fetchAnnouncementsMigration ({ state, commit, getters }, { options, account }) {
      commit('fetching')

      try {
        const { total, items } = await api.mercadoLivre.getAnnouncementsMigration(options, account)

        commit('setFetchData', {
          items, total, options
        })
      } catch (error) {
        notifier.error('Falha ao buscar os anúncios para migração.', 'Erro')
      }
    },
    async fetchMoreAnnouncementsMigration ({ state, commit, getters }, { options, account }) {
      commit('fetching')

      try {
        const { total, items } = await api.mercadoLivre.getAnnouncementsMigration(options, account)

        for (let i in items) {
          state.announcementsMigration.push(items[i])
        }

        state.total = total
      } catch (error) {
        options.finished = true
        notifier.error('Falha ao buscar os anúncios para migração.', 'Erro')
      }
    },
    async clearAnnouncementsMigration ({ state, commit }) {
      const items = []
      commit('setFetchData', {
        items
      })
    }
  },
  getters: {
    getAccount: state => identifier => state.announcementsMigration.find(account => account.identifier === identifier)
  },
  mutations: {
    setFetchData (state, { items, total, options }) {
      state.total = total
      state.announcementsMigration = items
      state.lastFetchOptions = {...options}
      state.fetching = false
    },
    fetching (state) {
      state.fetching = true
    },
    setItem (state, newItem) {
      const item = state.announcementsMigration.find(item => item.identifier === newItem.identifier)
      if (item) {
        merge(item, newItem)
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/mercadoLivreAnnouncementsMigration.js